// extracted by mini-css-extract-plugin
export default {"container":"Cu-z","ratingLayout":"Du-z","ratingLabel":"Eu-z","nonInteractiveRatingLabel":"Fu-z"};